<template>
  <div class="table-page-wrapper">

    <div v-show="searchStatus" class="search-wrapper">
      <el-input v-model="tableParams.dauName" clearable  placeholder="请输入DAU名称"/>
      <el-select v-model="tableParams.status" clearable placeholder="请选择是否开启" >
        <el-option label="开启" :value="0"></el-option>
        <el-option label="停用" :value="1"></el-option>
      </el-select>
      <base-date-picker @changeDate="changeDate"/>
      <el-button @click="toQuery" type="primary" >搜索</el-button>
    </div>

    <div class="table-wrapper">
      <table-column @search="searchColumn" @refresh="toQuery" @change="changeColumn" :column="columns"
                    style="padding-bottom: 10px;">
        <el-button @click="add" type="primary" size="small">新增</el-button>
      </table-column>

      <el-table v-loading="tableLoading" :data="tableData" height="80vh" :header-cell-style="{ background: '#fafafa' }"
                :summary-method="tableSummary" show-summary highlight-current-row :load="load"
                :tree-props="{ children: 'children', hasChildren: 'hasChildren' }" ref="report" row-key="id" lazy
                size="small"
                class="js-table" style="width: 100%" @sort-change="sortChange">

        <el-table-column v-if="tableParams.isTime" sortable prop="timeHour" label="上报时间" align="center"/>
        <el-table-column v-for="(v, i) in checkColumns" :prop="v.field" :label="v.title" :width="v.width" :sortable="
        v.field === 'dauDspSlotReqSmt' ||
        v.field === 'resSmt' ||
        v.field === 'uniShowSmt' ||
        v.field === 'uniClkSmt' ||
        v.field === 'dpSmt' ||
        v.field === 'clickRate' ||
        v.field === 'showRat' ||
        v.field === 'dpRate' ||
        v.field === 'fillingRate'" :min-width="v.minWidth" :key="i" align="center">
          <template v-slot="scope">
            <el-switch v-if="v.field === 'isEnable'&&scope.row['dauId']  " v-model="scope.row.status"
                       active-color="#13ce66" :active-value="0"
                       :inactive-value="1" @change="onChange(scope.row)"/>
            <el-switch v-if="v.field === 'isUniformPut'&&scope.row['dauId']  " v-model="scope.row.uniformPut"
                       active-color="#13ce66" :active-value="0"
                       :inactive-value="1" @change="onChangeUniformPutStatus(scope.row)"/>
            <el-switch v-if="v.field === 'isIgnoreQps'&&scope.row['dauId']  " v-model="scope.row.ignoreQps"
                       active-color="#13ce66" :active-value="0"
                       :inactive-value="1" @change="onChangeIgnoreQpsStatus(scope.row)"/>
            <span v-else>{{ scope.row[v.field] }}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" fixed="right" align="center" width="100">
          <template v-slot="scope" align="center">
            <el-button @click="update(scope.row)" type="success" size="mini"
                       :disabled="!scope.row['dauId']">编辑
            </el-button>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination @size-change="sizeChange" @current-change="currentChange" :total="pagination.total"
                     :pager-count="6" :current-page="pagination.pageNum" :page-size="pagination.pageSize"
                     :page-sizes="[10, 30, 60]"
                     background layout="total,sizes,prev,pager,next" style="margin-top: 40px;"/>
    </div>

    <m-form @submit="toQuery" ref="form" :title="(type + 'DAU')"/>

  </div>
</template>

<script>
import TableColumn from '@/components/TableColumn'
import SearchDspSelect from '@/components/SearchDspSelect'
import BaseDatePicker from '@/components/BaseDatePicker'
import mForm from './form'

import initTableMixin from '@/mixins/initTable'
import { uuid } from '@/util/util'
import {
  DauDetailList,
  updateDauIgnoreQpsStatus,
  updateDauStatus,
  updateDauUniformPutStatus
} from '@/api/manage/dsp/setDau'

export default {
  name: 'Manage/dsp',
  components: {
    TableColumn,
    mForm,
    SearchDspSelect,
    BaseDatePicker
  },
  mixins: [initTableMixin],
  data () {
    return {
      columns: [
        { field: 'dauName', title: '已设置DAU名称' },
        { field: 'dauNum', title: '已设DAU' },
        { field: 'dauDspSlotReqSmt', title: 'DAU总请求数' },
        { field: 'totalDau', title: 'DAU真实请求数' },
        { field: 'resSmt', title: '填充总数' },
        { field: 'uniShowSmt', title: '展示数' },
        { field: 'uniClkSmt', title: '点击数' },
        { field: 'dpSmt', title: '唤起数' },
        { field: 'clickRate', title: '点击率' },
        { field: 'showRat', title: '展示率' },
        { field: 'dpRate', title: '吊起率' },
        { field: 'fillingRate', title: '填充率' },
        { field: 'isEnable', title: '是否启用' },
        { field: 'isUniformPut', title: '是否匀速' },
        { field: 'isIgnoreQps', title: '是否无视qps' }
      ],
      getDspType: ['cpm', 'cpd', '通用'],
      type: ''
    }
  },
  created () {
  },
  mounted () {
    this.$nextTick(() => {
      this.init()
    })
  },
  provide () {
    return {
      init: this.init
    }
  },
  methods: {
    beforeInit () {
      this.tableUrl = '/webDauConfig/list'
      return true
    },
    afterInit (res) {
      this.tableData = this.generateTableId(res.data.records, 0)
    },
    changeDate (date) {
      this.tableParams.startTime = date.startTime
      this.tableParams.endTime = date.endTime
    },
    sortChange (column, prop, order) {
      if (column.order === 'ascending') {
        this.tableParams.asc = column.prop
        this.tableParams.desc = ''
      } else if (column.order === 'descending') {
        this.tableParams.desc = column.prop
        this.tableParams.asc = ''
      }
      this.init()
    },
    add () {
      this.type = '新增'
      this.$refs.form.show()
    },
    update (row) {
      this.type = '修改'
      this.$refs.form.show(row)
    },
    load (tree, treeNode, resolve) {
      this.$nextTick(() => {
        const search = {
          dauId: tree.dauId,
          asc: this.tableParams.asc,
          desc: this.tableParams.desc,
          pageNum: this.pagination.pageNum,
          pageSize: this.pagination.pageSize
        }
        if (tree.reportTime === undefined) {
          search.endTime = this.tableParams.endTime
          search.startTime = this.tableParams.startTime
          if (this.dateFormatId === 2) {
            search.startTime = search.startTime + '00'
            search.endTime = search.endTime + '23'
          }
        } else {
          search.endTime = tree.reportTime
          search.startTime = tree.reportTime
        }
        DauDetailList(search).then((res) => {
          if (res.code === 200) {
            resolve(this.generateTableId(res.data, tree.id))
          }
        })
      })
    },
    generateTableId (data, base) {
      if (!data) return []
      for (let i = 0; i < data.length; i++) {
        data[i].id = uuid()
        if (base === 0) {
          data[i].hasChildren = true
        } else {
          data[i].dauName = data[i].dspSlotName
        }
      }
      return data
    },
    onChange (e) {
      updateDauStatus({
        dauId: e.dauId,
        status: e.status
      }).then(res => {
        if (res.code === 200) {
          this.$message.success('修改成功')
        }
      })
    },
    onChangeUniformPutStatus (e) {
      updateDauUniformPutStatus({
        dauId: e.dauId,
        uniformPutStatus: e.uniformPut
      }).then(res => {
        if (res.code === 200) {
          this.$message.success('修改成功')
        }
      })
    },
    onChangeIgnoreQpsStatus (e) {
      updateDauIgnoreQpsStatus({
        dauId: e.dauId,
        ignoreQpsStatus: e.ignoreQps
      }).then(res => {
        if (res.code === 200) {
          this.$message.success('修改成功')
        }
      })
    }

  }
}
</script>

<style scoped lang="scss">
.search-wrapper {
  padding: 15px 15px 5px;
  margin-bottom: 10px;
  background: #ffffff;

  & > * {
    margin-right: 15px;
    margin-bottom: 10px;

    &:last-child {
      margin-right: 0;
    }
  }

  & > .el-select,
  & > .el-input {
    width: 220px;
  }
}

.table-wrapper {
  padding: 15px;
  background: #ffffff;

  .table__operation {
    padding-bottom: 10px;
  }
}

.el-table::before {
  height: 0;
}

.el-pagination {
  text-align: right;
}
</style>
